import { ReactComponent as LevelUpAltIcon } from "@fortawesome/fontawesome-free/svgs/solid/level-up-alt.svg";
import SvgIcon, { type SvgIconProps } from "../SvgIcon";

const LevelUpAlt = (props: SvgIconProps) => (
    <SvgIcon {...props} size={props.size || "fs"}>
        <LevelUpAltIcon />
    </SvgIcon>
);

export default LevelUpAlt;
